module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n  " + _vm._s(_vm.rowData) + "\n  "), _c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rowData.system_set), function(row) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.rowData.department.name))]), _vm._v(" "), _vm._m(1, true)])
  }), 0)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("名稱")]), _vm._v(" "), _c('th', [_vm._v("位置")]), _vm._v(" "), _c('th', [_vm._v("動作")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('button', {
    staticClass: "btn btn-danger"
  }, [_vm._v("刪除")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-inline"
  }, [_c('select', {
    staticClass: "form-control col-10"
  }, [_c('option', [_vm._v("Default select")])]), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("新增")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de9dda0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/SystemSettings/AreaSettingsDetail.vue
// module id = 1382
// module chunks = 1